import {
  ChangeDetectionStrategy, ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject, Input,
  OnInit,
  Output
} from "@angular/core";
import {PANEL_DATA} from "../../../../commons/angular/services/panel.service";
import {AgentModel} from "../../../../agents/angular/models/agent.model";

require('./schedule-availability-approval-dialog.scss');
@Component({
  standalone: false,
  selector: 'app-schedule-availability-approval-dialog',
  templateUrl: './schedule-availability-approval-dialog.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ScheduleAvailabilityApprovalDialogComponent implements OnInit {

  @Output() onClose = new EventEmitter<any>();

  public agent: AgentModel;
  public schedule: any;

  constructor(@Inject(PANEL_DATA) public data: {agent: AgentModel, agentSchedule: any},
              @Inject(ChangeDetectorRef) private cdr: ChangeDetectorRef, @Inject('planningProjectsService') private planningProjectsService) {
  }

  ngOnInit() {
    this.agent = this.data.agent;
    this.schedule = this.data.agentSchedule;
  }

  onApprove() {
    this.onClose.emit({approved: true});
  }

  onReject() {
    this.onClose.emit({approved: false});
  }

  onCancel() {
    this.onClose.emit();
  }

}
